function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

export default {
  data: function data() {
    return {
      topScrollHandler: null,
      bottomScrollHandler: null,
      nextPageUrl: null,
      prevPageUrl: null,
      request: null,
      infiniteScroll: null
    };
  },
  computed: {
    bottomAnchorStyles: function bottomAnchorStyles() {
      return {
        display: this.infiniteScroll && this.nextPageUrl ? "block" : "none"
      };
    }
  },
  methods: {
    enableInfiniteScrollIfApplicable: function enableInfiniteScrollIfApplicable() {
      this.$removeViewportChangeListeners(this.topScrollHandler);
      this.$removeViewportChangeListeners(this.bottomScrollHandler);
      var prevPage = this.spec.prevPage || {};
      var nextPage = this.spec.nextPage || {};
      this.infiniteScroll = nextPage.autoload == "asNeeded";
      var onScrollToBottom = this.spec.onScrollToBottom;
      var onScrollToTop = this.spec.onScrollToTop;

      if (this.infiniteScroll) {
        this.nextPageUrl = nextPage.url;
        this.prevPageUrl = prevPage.url;
      }

      if (this.nextPageUrl || onScrollToBottom) {
        this._registerBottomScroll(onScrollToBottom);
      }

      if (this.prevPageUrl || onScrollToTop) {
        this._registerTopScroll(onScrollToTop);
      }
    },
    _registerTopScroll: function _registerTopScroll(onScrollToTop) {
      var _this = this;

      // TODO: Consider adding support for prevPageUrl
      this.topScrollHandler = this.$onVisibilityChange(this.$refs.topAnchor, function (el, visible) {
        if (visible) {
          _this._handleTopScroll(onScrollToTop);
        }
      });
      this.$addViewportChangeListeners(this.topScrollHandler); // this.topScrollHandler();
    },
    _handleTopScroll: function _handleTopScroll(onScrollToTop) {
      GLib.action.execute(onScrollToTop, this);
    },
    _registerBottomScroll: function _registerBottomScroll(onScrollToBottom) {
      var _this2 = this;

      this.bottomScrollHandler = this.$onVisibilityChange(this.$refs.bottomAnchor, function (el, visible) {
        if (visible) {
          _this2._handleBottomScroll(onScrollToBottom);
        }
      });
      this.$addViewportChangeListeners(this.bottomScrollHandler); // NOTE: Right now there is an issue where after popping to previus page, the page auto-loads from the beginning
      // again, so we get duplicate rows.
      // this.bottomScrollHandler();
    },
    _handleBottomScroll: function _handleBottomScroll(onScrollToBottom) {
      var _this3 = this;

      if (this.nextPageUrl) {
        this.request = Utils.http.execute({
          url: this.nextPageUrl
        }, "GET", this, function (response) {
          var nextPage = response.nextPage;

          if (_this3.$type.isObject(nextPage)) {
            _this3.nextPageUrl = response.nextPage.url;
          } else {
            _this3.nextPageUrl = null;
          }

          var _iterator = _createForOfIteratorHelper(response.sections),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var section = _step.value;

              _this3.sections.push(section);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          Utils.history.updatePage();
        });
      }

      GLib.action.execute(onScrollToBottom, this);
    },
    autoloadAll: function autoloadAll(nextPage) {
      var vm = this;

      if (!this.$type.isObject(nextPage)) {
        return;
      }

      if (nextPage.autoload !== "all") {
        return;
      }

      var nextPageUrl = nextPage.url;
      this.request = Utils.http.execute({
        url: nextPageUrl
      }, "GET", vm, function (response) {
        var _iterator2 = _createForOfIteratorHelper(response.sections),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var section = _step2.value;
            vm.sections.push(section);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        vm.autoloadAll(response.nextPage);
      });
    },
    cancelAutoloadRequest: function cancelAutoloadRequest() {
      // Avoid old data coming in when this component gets reused.
      if (this.request) {
        this.request.cancel();
      }
    }
  }
};